import {FilterData, FilteringFlow, Parser} from "@filtering.js/filtering.js/ui";
import {animateInViewport} from "../transition";
import {updateGoogleMapMarkers} from "./map";
import {esc_title} from "../clinic-finder";
// import {loadMore} from "../load-more";

$( function() {
	const $filtering = $( '#filtering' );
	if ( $filtering.length ) {
		const filteringElement = $filtering[ 0 ];
		const filterCheckedClass = 'current';

		const $search = $( '#clinic-filtering-search-input' );
		$search.on( 'keyup search', ( event ) => {
			filteringFlow.filter();
		} );
		$( '#clinic-filtering-search-button' ).click( function( e ) {
			e.preventDefault();
			filteringFlow.filter();
		} );

		class MyFilteringFlow extends FilteringFlow {

			get parserOptions() {
				return { filterCheckedClass };
			}

			get filteringOptions() {
				return {
					filterItem: function( item, schema ) {
						if ( $search.length ) {
							const searchWords = $search.val()
								.split( /\s+/g )
								.filter( ( w ) => w !== '' )
								.map( esc_title );
							const $item = $( item.data.element );
							const itemSearch = esc_title( $item.attr( 'data-search-string' ) );
							return searchWords.every( ( searchWord ) => {
								return itemSearch.indexOf( searchWord ) !== -1;
							} );
						} else {
							return true;
						}
					},
				};
			}

			handleFilterResult( result, filterData ) {
				super.handleFilterResult( result );
				$( '.clinic-filtering-results', $filtering ).toggleClass( 'hidden', result.filteredItems.length === 0 );
				$( '.clinic-filtering-no-results', $filtering ).toggleClass( 'hidden', result.filteredItems.length > 0 );

				this.updateLoadMore( result );

				animateInViewport();

				this.updateGoogleMarkers( result );

				storeFiltersToHash( filterData );
			}

			updateLoadMore( result ) {
				if ( $( '.load-more' ).length === 0 ) {
					return;
				}

				for ( const item of result.allItems ) {
					item.data.element.classList.add( 'load-more-hidden' );
					item.data.element.querySelector( '.property' ).classList.remove( 'active' );
				}
				result.filteredItems.map( function( item ) {
					const element = item.data.element;
					return {
						index: parseInt( element.dataset.index ),
						element: element,
					};
				} ).sort( function( e1, e2 ) {
					return e2.index - e1.index;
				} ).forEach( function( item ) {
					item.element.parentElement.prepend( item.element );
				} );
				// loadMore( $( '.load-more' ) );
			}

			updateGoogleMarkers( result ) {
				const ids = new Set();
				for ( const item of result.filteredItems ) {
					if ( item.data.element.dataset.clinicIds ) {
						for ( const clinicId of item.data.element.dataset.clinicIds.split( ',' ) ) {
							ids.add( `clinic-${clinicId}` );
						}
					} else {
						ids.add( item.data.element.id );
					}
				}
				updateGoogleMapMarkers( [...ids] );
			}
		}

		const storeHash = filteringElement.dataset.storeHash === 'true';
		const filteringFlow = new MyFilteringFlow( filteringElement, {
			filteredItemClass: 'hidden',
			triggerFilterAfterInitializing: !storeHash,
		} );
		window.addEventListener( 'hashchange', loadFiltersFromHash );
		if ( storeHash ) {
			loadFiltersFromHash();
		}

		function loadFiltersFromHash() {
			if ( !storeHash ) {
				return;
			}

			const hash = decodeURIComponent( window.location.hash.substring( 1 ) );
			const filteringData = new FilterData();
			if ( hash ) {
				const filteringAsQueryParams = new URLSearchParams( hash );
				for ( const [groupName, filterName] of filteringAsQueryParams ) {
					filteringData.checkFilter( groupName, filterName );
				}
			}
			filteringFlow.filter( filteringData );
		}

		function storeFiltersToHash( filterData ) {
			if ( !storeHash ) {
				return;
			}

			const filteringAsQueryParams = new URLSearchParams();
			for ( const [groupName, checkedFilters] of filterData.checkedFilters ) {
				for ( const checkedFilter of checkedFilters ) {
					filteringAsQueryParams.append( groupName, checkedFilter );
				}
			}

			const newHash = filteringAsQueryParams.toString();
			updateHash( newHash );
		}

		function updateHash( newHash ) {
			if ( newHash !== window.location.hash.substring( window.location.hash.indexOf( '#' ) + 1 ) ) {
				if ( newHash ) {
					window.location.hash = newHash;
				} else {
					const uri = window.location.toString();
					history.pushState( true, '', uri.substring( 0, uri.indexOf( "#" ) ) );
				}
			}
		}
	}
} );
